import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=a870986c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=a870986c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a870986c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a870986c')) {
      api.createRecord('a870986c', component.options)
    } else {
      api.reload('a870986c', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=a870986c&scoped=true", function () {
      api.rerender('a870986c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/footer/type3/Footer.vue"
export default component.exports